"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link PriceListSettings price list settings}.
 *
 * @author Radek Beran
 */


var PriceListSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceListSettingsConverter, _DataObjectConverter_);

  function PriceListSettingsConverter() {
    _classCallCheck(this, PriceListSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListSettingsConverter).apply(this, arguments));
  }

  return PriceListSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceListSettingsConverter = PriceListSettingsConverter;